import { observable } from 'mobx';
import settingsStore from 'stores/SettingsStore';
import { localeStrings as strings } from 'applicationConfig';

import _get from 'lodash/get';

const notHandledErrors = [ 401 ];
const notErrors = [ 404 ];

class ErrorHandler {
  @observable lastErrorCode = null;

  handle(error = {}) {
    const defaultMessage = strings.generic.errorMessages.errorHasOccurred;
    const message = this.parseMessage(error, defaultMessage);

    this.lastErrorCode = error.status;

    if (notHandledErrors.indexOf(error.status) === -1) {
      if (notErrors.indexOf(error.status) === -1) {
        settingsStore.showSimpleError(defaultMessage);
      } else {
        settingsStore.showSimpleAlert(message);
      }
    }

    throw error;
  }

  parseMessage(error, defaultMessage) {
    let messages = _get(error, 'data.error.message') || _get(error, 'data.Message') || defaultMessage;
    return Array.isArray(messages) ? messages.join(', ') : messages;
  }
}

const errorHandler = new ErrorHandler();

export default errorHandler;



// WEBPACK FOOTER //
// ./src/services/ErrorHandler.js